import { render, staticRenderFns } from "./AffTable.vue?vue&type=template&id=43656794&scoped=true&"
import script from "./AffTable.vue?vue&type=script&lang=js&"
export * from "./AffTable.vue?vue&type=script&lang=js&"
import style0 from "./AffTable.vue?vue&type=style&index=0&id=43656794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43656794",
  null
  
)

export default component.exports